import { Controller } from '@hotwired/stimulus'
import { Lottie } from '../../api/models/types'
import { getComponentContext, lifecycleTrigger } from '../../helpers/controllerHelpers/utils'
import { setLottieScript } from '../../helpers/utils'

export default class extends Controller {
  static values = {
    autoplay: Boolean,
    loop: Boolean,
    controls: Boolean,
    hover: Boolean,
    mode: String,
    src: String,
  }

  lottieScriptUrl: string
  lottieScriptFound: boolean
  declare componentId: string
  declare modeValue: string
  declare autoplayValue: string
  declare loopValue: string
  declare controlsValue: string
  declare hoverValue: string
  declare srcValue: string
  component: Lottie
  flowEl: Element | null

  connect() {
    setLottieScript().then((lottieScriptUrl) => {
      if (lottieScriptUrl.status === 'added') this.setUpLottie()
    })

    const { componentId, component, flowEl } = getComponentContext(this)
    this.component = component as Lottie
    this.componentId = componentId
    this.flowEl = flowEl
    lifecycleTrigger(this, 'mounted')
  }

  disconnect() {
    lifecycleTrigger(this, 'unmounted')
  }

  setUpLottie() {
    const lottiePlayer = this.element.querySelector('lottie-player')
    //* We remove the lottie-player element, copy it and re-add the copy to force it to re-render
    if (lottiePlayer) {
      const lottiePlayerCopy = lottiePlayer.cloneNode(true)
      lottiePlayer.remove()
      this.element.appendChild(lottiePlayerCopy)
    }
  }
}
